<template>
    <div class="container mescroll-touch">
        <img src="../../assets/images/jiaotongtopnew.png" class="img" />
        <!-- <img src="../../assets/images/topguanggao.png" class="guanggaoimg" /> -->
        <div class="model">
            <div class="modelline">
                <div class="modeltitle">
                    <img src="../../assets/images/jiaotongicon.png" class="modeltitleimg" />
                    <div class="modeltitletext">会议地点</div>
                </div>
            </div>
            <div class="neirong">
                <div class="name">上海光大会展中心国际大酒店（中国上海市徐汇区漕宝路66号）</div>
                <!-- <div class="newtext">点击以下地图即可查询交通路线</div> -->
            </div>
            <img src="../../assets/images/acmedpos.png" alt="" class="posimg">
            <!-- <div class="mapview" @click="goapp(31.167118, 121.4263217, '光大会展中心国际大酒店')">
                <el-amap class="amap-box" :vid="'amap-vue'" @init="handleMapInit" :zoom="zoom" :center="position">
                    <el-amap-marker :vid="'marker'" :position="position" :events="events" ref="map"></el-amap-marker>
                </el-amap>
            </div> -->
        </div>

        <div class="model">
            <div class="modelline">
                <div class="modeltitle">
                    <img src="../../assets/images/jiaotongicon.png" class="modeltitleimg" />
                    <div class="modeltitletext">住宿信息</div>
                </div>
            </div>
            <div class="neirong">
                <div class="name"><span class="perplebold"> · 上海光大会展中心国际大酒店</span></div>
                <div class="name"><span class="perplebold"> · 上海华夏假日酒店</span></div>
            </div>
        </div>

        <div class="model">
            <div class="modelline">
                <div class="modeltitle">
                    <img src="../../assets/images/jiaotongicon.png" class="modeltitleimg" />
                    <div class="modeltitletext">公共交通</div>
                </div>
            </div>
            <div class="neirong">
                <div class="name"><span class="darkperplebold">地铁1号线/地铁12号线漕宝路站约0.4公里</span></div>
                <br />
                <div class="name">距离信息：</div>
                <div class="name"><span class="perplebold">虹桥国际机场/虹桥火车站约16公里</span>，驾车约40分钟</div>
                <div class="name"><span class="perplebold">浦东国际机场约44公里</span>，驾车约60分钟</div>
                <div class="name"><span class="perplebold">上海火车站约14公里</span>，驾车约40分钟</div>
                <div class="name"><span class="perplebold">上海南站约7.3公里</span>，驾车约20分钟</div>
            </div>
        </div>
        <floatback></floatback>
    </div>
</template>

<script>
import floatback from './floatback.vue';
import mixin from '../../common/mixin/mixins'
export default {
    name: 'jiaotong',
    data() {
        return {
            map: null,
            zoom: 17,
            position: [121.4263217, 31.167118],
            events: {},
        }
    },
    mixins: [mixin],
    components: {
        floatback
    },
    created() {
        this.initacmedShare();
        document.title = "ACMED第一届学术年会";
    },
    methods: {
    }
}
</script>

<style lang="scss" scoped>
.container {
    height: 100%;
    width: 100%;
    // background: rgb(228, 236, 255);
}

.img {
    display: block;
    width: 100%;
    margin-bottom: .2rem
}

.zuzhititleimg {
    display: block;
    width: 55%;
    margin: auto;
    margin-bottom: .2rem
}

.zuzhititleimg1 {
    display: block;
    width: 55%;
    margin: .5rem auto .2rem auto;
}

.guanggaoimg {
    display: block;
    width: 92%;
    margin: 0.5rem auto;
}

.modelline {
    border-bottom: 1px solid rgb(0, 53, 133);
    border-bottom-left-radius: 50rem;
}

.modeltitle {
    background: rgb(0, 53, 133);
    width: 37%;
    display: flex;
    flex-direction: row;
    padding: 0.1rem;
    border-radius: 30px 50px 0px 30px;
}

.modeltitle1 {
    background: rgb(0, 53, 133);
    width: 45%;
    display: flex;
    flex-direction: row;
    padding: 0.1rem;
    border-radius: 30px 50px 0px 30px;
}

.modeltitleimg {
    display: block;
    width: 15%;
    background: #fff;
    border-radius: 50rem;
    width: 0.5rem;
    height: 0.5rem;
    box-sizing: border-box;
    padding: 0.05rem 0.08rem;
}

.modeltitletext {
    margin-left: 0.2rem;
    color: #fff;
    font-weight: bold;
    // font-size: 16px;
}

.model {
    width: 92%;
    margin: auto;
    margin-top: 0.5rem;
}

.model1 {
    width: 92%;
    margin: auto;
    margin-top: 0.5rem;
    padding-bottom: 1rem;
}

.center {
    text-align: center;
}

.preple {
    color: rgb(0, 53, 133);
}

.neirong {
    margin-top: .3rem
}

.ziti {
    font-size: .37rem;
}

.neirong {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    width: 95%;
    margin: auto;
    margin-top: 0.3rem;
}

.name {
    width: 100%;
    // text-align: center;
    font-size: .37rem;
    margin: 0.08rem 0;
    // margin: 0.1rem 0;
}

.name1 {
    width: 50%;
    text-align: right;
    font-size: .37rem;
    // margin: 0.1rem 0;
}

.perplebold {
    color: rgb(0, 53, 133);
    font-weight: bold;
}

.wait {
    text-align: center;
    color: rgb(0, 53, 133);
    font-weight: bold;
    font-size: .55rem;
    margin-top: 20%;
}

.mapview {
    width: 95%;
    margin: auto;
    height: 5.5rem;
    margin-top: 0.3rem;
}

.darkperplebold {
    color: rgb(0, 53, 133);
    font-weight: bold;
}

.newtext {
    margin-top: 0.5rem;
    font-weight: bold;
}

.posimg {
    width: 100%;
    margin-top: 0.5rem;
}
</style>